// import React from 'react';
// import { ArrowUpRight, ArrowRight } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import backgroundImage from '../assets/About/background.avif';
// import tallImage from '../assets/About/tall_image.avif';
// import rightImage from '../assets/About/right_image.avif';
// import bottomRightImage from '../assets/About/bottom_right.avif';

// // Reusable component for the Glassmorphism Text Overlay
// const GlassOverlay = ({ title, description }) => (
//   <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 via-black/60 to-transparent backdrop-blur-[2px] flex flex-col justify-end min-h-[40%] transition-all duration-500 group-hover:min-h-[45%]">
//     <h3 className="text-xl font-bold text-white mb-2 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
//       {title}
//     </h3>
//     <p className="text-white/80 text-sm leading-relaxed opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-75">
//       {description}
//     </p>
//   </div>
// );

// export default function App() {
//   const navigate = useNavigate();
//   const { t, i18n } = useTranslation();
//   const isRTL = i18n.language === 'ar' || i18n.language === 'ku';

//   return (
//     <div className="relative min-h-screen flex items-center justify-center px-4 py-8 md:px-6 md:py-0 lg:px-12 lg:py-16 font-sans text-slate-900 overflow-hidden">
//       {/* Hero-like Background */}
//       <div className="absolute inset-0">
//         <img
//           src={backgroundImage}
//           alt="Construction Background"
//           className="w-full h-full object-cover blur-md"
//         />

//         {/* Global Dark Overlays */}
//         <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30" />
//         <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
//       </div>

//       <div className="relative z-20 max-w-7xl mx-auto w-full">

//         {/* Mobile Layout */}
//         <div className="md:hidden flex flex-col gap-6">
//           {/* Main Info Card */}
//           <div className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] rounded-lg p-4">
//             <div className="text-white/80 text-xs font-semibold tracking-[0.15em] uppercase mb-4">
//               {t('about.established')}
//             </div>

//             <h1 className="text-lg font-medium text-white leading-tight mb-4">
//               {t('about.title')} <br />{t('about.titleHighlight')}
//             </h1>

//             <div className="text-sm text-white/90 font-normal leading-relaxed space-y-3">
//               <p>
//                 {t('about.description')}
//               </p>
//             </div>
//           </div>

//           {/* Images */}
//           <div className="grid grid-cols-1 gap-3 w-full">
//             <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[250px]">
//               <img
//                 src={tallImage}
//                 alt="Construction Services"
//                 className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//               />
//               <GlassOverlay
//                 title={t('about.services.construction.title')}
//                 description={t('about.services.construction.description')}
//               />
//             </div>

//             <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[200px]">
//               <img
//                 src={rightImage}
//                 alt="Logistics Services"
//                 className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//               />
//               <GlassOverlay
//                 title={t('about.services.logistics.title')}
//                 description={t('about.services.logistics.description')}
//               />
//             </div>

//             <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[200px]">
//               <img
//                 src={bottomRightImage}
//                 alt="Environmental Services"
//                 className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//               />
//               <GlassOverlay
//                 title={t('about.services.environmental.title')}
//                 description={t('about.services.environmental.description')}
//               />
//             </div>
//           </div>

//           {/* CTA Button */}
//           <div>
//             <button onClick={() => navigate('/about')} className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-6 py-3 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 justify-center text-sm min-h-[48px] touch-manipulation w-full">
//               {t('about.cta')}
//               <ArrowRight className={`w-4 h-4 transition-transform duration-300 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : 'group-hover:translate-x-1'}`} />
//             </button>
//           </div>
//         </div>

//         {/* Desktop Layout */}
//         <div className="hidden md:grid grid-cols-12 gap-12 lg:gap-20 items-center">
//           {/* Left Content Column */}
//           <div className="col-span-5 flex flex-col gap-8">
//             {/* Main Info Card */}
//             <div className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] rounded-xl lg:rounded-2xl p-6 lg:p-8">
//               <div className="text-white/80 text-xs font-semibold tracking-[0.15em] uppercase mb-4">
//                 {t('about.established')}
//               </div>

//               <h1 className="text-xl lg:text-2xl xl:text-3xl font-medium text-white leading-tight mb-4">
//                 {t('about.title')} <br />{t('about.titleHighlight')}
//               </h1>

//               <div className="text-base text-white/90 font-normal leading-relaxed space-y-3">
//                 <p>
//                   {t('about.description')}
//                 </p>
//               </div>
//             </div>

//             {/* CTA Button */}
//             <div>
//               <button onClick={() => navigate('/about')} className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 justify-center text-base min-h-[56px] touch-manipulation">
//                 {t('about.cta')}
//                 <ArrowRight className={`w-5 h-5 transition-transform duration-300 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : 'group-hover:translate-x-1'}`} />
//               </button>
//             </div>
//           </div>

//           {/* Right Image Grid Column */}
//           <div className="col-span-7 h-full w-full">
//             <div className="grid grid-cols-2 grid-rows-2 gap-4 h-[400px] lg:h-[500px] xl:h-[600px] w-full">
//               {/* Tall Image (Left) */}
//               <div className="row-span-2 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
//                 <img
//                   src={tallImage}
//                   alt="Construction Services"
//                   className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                 />
//                 <GlassOverlay
//                   title={t('about.services.construction.title')}
//                   description={t('about.services.construction.description')}
//                 />
//               </div>

//               {/* Top Right Image */}
//               <div className="col-start-2 row-start-1 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
//                 <img
//                   src={rightImage}
//                   alt="Logistics Services"
//                   className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                 />
//                 <GlassOverlay
//                   title={t('about.services.logistics.title')}
//                   description={t('about.services.logistics.description')}
//                 />
//               </div>

//               {/* Bottom Right Image */}
//               <div className="col-start-2 row-start-2 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
//                 <img
//                   src={bottomRightImage}
//                   alt="Environmental Services"
//                   className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
//                 />
//                 <GlassOverlay
//                   title={t('about.services.environmental.title')}
//                   description={t('about.services.environmental.description')}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// }



import React from 'react';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import backgroundImage from '../assets/About/background.avif';
import tallImage from '../assets/About/tall_image-optimized.avif';
import rightImage from '../assets/About/right_image-optimized.avif';
import bottomRightImage from '../assets/About/bottom_right-optimized.avif';



// Reusable component for the Glassmorphism Text Overlay
const GlassOverlay = ({ title, description }) => (
    <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/90 via-black/60 to-transparent backdrop-blur-[2px] flex flex-col justify-end min-h-[40%] transition-all duration-500 group-hover:min-h-[45%]">
        <h3 className="text-xl font-bold text-white mb-2 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
            {title}
        </h3>
        <p className="text-white/80 text-sm leading-relaxed opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-75">
            {description}
        </p>
    </div>
);

export default function App() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar' || i18n.language === 'ku';

    return (
        <div className="relative min-h-screen flex items-center justify-center px-4 py-8 md:px-6 md:py-0 lg:px-12 lg:py-16 font-sans text-slate-900 overflow-hidden">
            {/* Hero-like Background */}
            <div className="absolute inset-0">
                <img
                    src={backgroundImage}
                    alt="Construction Background"
                    className="w-full h-full object-cover blur-md"
                    // ⭐️ Lazy Loading added here
                    loading="lazy"
                />

                {/* Global Dark Overlays */}
                <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-black/30" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
            </div>

            <div className="relative z-20 max-w-7xl mx-auto w-full">

                {/* Mobile Layout */}
                <div className="md:hidden flex flex-col gap-6">
                    {/* Main Info Card */}
                    <div className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] rounded-lg p-4">
                        <div className="text-white/80 text-xs font-semibold tracking-[0.15em] uppercase mb-4">
                            {t('about.established')}
                        </div>

                        <h1 className="text-lg font-medium text-white leading-tight mb-4">
                            {t('about.title')} <br />{t('about.titleHighlight')}
                        </h1>

                        <div className="text-sm text-white/90 font-normal leading-relaxed space-y-3">
                            <p>
                                {t('about.description')}
                            </p>
                        </div>
                    </div>

                    {/* Images */}
                    <div className="grid grid-cols-1 gap-3 w-full">
                        <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[250px]">
                            <img
                                src={tallImage}
                                alt="Construction Services"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                // ⭐️ Lazy Loading added here
                                loading="lazy"
                            />
                            <GlassOverlay
                                title={t('about.services.construction.title')}
                                description={t('about.services.construction.description')}
                            />
                        </div>

                        <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[200px]">
                            <img
                                src={rightImage}
                                alt="Logistics Services"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                // ⭐️ Lazy Loading added here
                                loading="lazy"
                            />
                            <GlassOverlay
                                title={t('about.services.logistics.title')}
                                description={t('about.services.logistics.description')}
                            />
                        </div>

                        <div className="relative group overflow-hidden rounded-xl border border-white/10 shadow-2xl h-[200px]">
                            <img
                                src={bottomRightImage}
                                alt="Environmental Services"
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                // ⭐️ Lazy Loading added here
                                loading="lazy"
                            />
                            <GlassOverlay
                                title={t('about.services.environmental.title')}
                                description={t('about.services.environmental.description')}
                            />
                        </div>
                    </div>

                    {/* CTA Button */}
                    <div>
                        <button onClick={() => navigate('/about')} className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-6 py-3 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 justify-center text-sm min-h-[48px] touch-manipulation w-full">
                            {t('about.cta')}
                            <ArrowRight className={`w-4 h-4 transition-transform duration-300 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : 'group-hover:translate-x-1'}`} />
                        </button>
                    </div>
                </div>

                {/* Desktop Layout */}
                <div className="hidden md:grid grid-cols-12 gap-12 lg:gap-20 items-center">
                    {/* Left Content Column */}
                    <div className="col-span-5 flex flex-col gap-8">
                        {/* Main Info Card */}
                        <div className="bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] rounded-xl lg:rounded-2xl p-6 lg:p-8">
                            <div className="text-white/80 text-xs font-semibold tracking-[0.15em] uppercase mb-4">
                                {t('about.established')}
                            </div>

                            <h1 className="text-xl lg:text-2xl xl:text-3xl font-medium text-white leading-tight mb-4">
                                {t('about.title')} <br />{t('about.titleHighlight')}
                            </h1>

                            <div className="text-base text-white/90 font-normal leading-relaxed space-y-3">
                                <p>
                                    {t('about.description')}
                                </p>
                            </div>
                        </div>

                        {/* CTA Button */}
                        <div>
                            <button onClick={() => navigate('/about')} className="group bg-white/5 backdrop-blur-2xl border border-white/10 shadow-[0_8px_32px_rgba(0,0,0,0.2)] text-white px-8 py-4 rounded-full font-medium hover:bg-white/10 transition-all duration-300 flex items-center gap-3 justify-center text-base min-h-[56px] touch-manipulation">
                                {t('about.cta')}
                                <ArrowRight className={`w-5 h-5 transition-transform duration-300 ${isRTL ? 'rotate-180 group-hover:-translate-x-1' : 'group-hover:translate-x-1'}`} />
                            </button>
                        </div>

                    </div>

                    {/* Right Image Grid Column */}
                    <div className="col-span-7 h-full w-full">
                        <div className="grid grid-cols-2 grid-rows-2 gap-4 h-[400px] lg:h-[500px] xl:h-[600px] w-full">
                            {/* Tall Image (Left) */}
                            <div className="row-span-2 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
                                <img
                                    src={tallImage}
                                    alt="Construction Services"
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    // ⭐️ Lazy Loading added here
                                    loading="lazy"
                                />
                                <GlassOverlay
                                    title={t('about.services.construction.title')}
                                    description={t('about.services.construction.description')}
                                />
                            </div>

                            {/* Top Right Image */}
                            <div className="col-start-2 row-start-1 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
                                <img
                                    src={rightImage}
                                    alt="Logistics Services"
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    // ⭐️ Lazy Loading added here
                                    loading="lazy"
                                />
                                <GlassOverlay
                                    title={t('about.services.logistics.title')}
                                    description={t('about.services.logistics.description')}
                                />
                            </div>

                            {/* Bottom Right Image */}
                            <div className="col-start-2 row-start-2 relative group overflow-hidden rounded-[2rem] border border-white/10 shadow-2xl h-full">
                                <img
                                    src={bottomRightImage}
                                    alt="Environmental Services"
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    // ⭐️ Lazy Loading added here
                                    loading="lazy"
                                />
                                <GlassOverlay
                                    title={t('about.services.environmental.title')}
                                    description={t('about.services.environmental.description')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}